import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
// Components
import { Snackbar } from "@/components/index";

@Component({
  components: {
    Snackbar,
  },
})
export default class UsersFeedbacks extends Vue {
  feedbacks: any[] = [];
  avgStars = "";

  headersFeedbacksTable = [
    {
      text: "Prénom",
      align: "start",
      value: "user.firstname",
      class: "indigo--text text--darken-4",
    },
    {
      text: "Nom",
      value: "user.lastname",
      class: "indigo--text text--darken-4",
    },
    {
      text: "Email",
      value: "user.email",
      class: "indigo--text text--darken-4",
    },
    {
      text: "Note",
      value: "stars",
      class: "indigo--text text--darken-4",
    },
    {
      text: "Message",
      value: "message",
      class: "indigo--text text--darken-4",
    },
  ];

  // ========== CRUD ========== //

  async allFeedbacks(): Promise<void> {
    this.feedbacks = (await axios.get(`/api/feedbacks`)).data as any[];
  }

  async getAvgStars(): Promise<void> {
    const avg = (await axios.get(`/api/feedbacks/avg-stars`)).data;
    this.avgStars = parseFloat(avg._avg.stars).toFixed(2);
  }

  mounted(): void {
    this.allFeedbacks();
    this.getAvgStars();
  }

  // ========== OTHER METHODS ========== //

  colorRow(item: any): any {
    const position = this.feedbacks.indexOf(item, 0);
    if (position % 2 == 0) {
      return "light-green lighten-5";
    }
  }

  showSnackbar(): void {
    const snackbar = this.$refs.snackbar as Snackbar;
    snackbar.show();
  }
}
